module.exports = __webpack_public_path__ + "img/blue-house.517a39e7.svg";